export const cities = {
    CITY_NAGPUR: 'nagpur', // Define city name here  
};

export const cityNameGlobal = cities.CITY_NAGPUR;
